import type { UserDetail } from '../entities/user.entity'
import type { UserRepository } from '../repositories/user_repository'

export class GetUserByIdUseCase {
  constructor(private readonly repository: UserRepository) {}

  execute(id: string): Promise<UserDetail> {
    return this.repository.getById(id)
  }
}
